import { z } from "zod/v4";

z.config({
  customError: (iss) => {
    if (iss.code === "invalid_type") {
      if (iss.input === undefined) {
        return `Required`;
      } else {
        return "Invalid";
      }
    }
    if (iss.code === "too_small" && iss.minimum === 1) {
      return `Required`;
    }
  },
});
export const contactSchema = z.object({
  email: z.email(),
  message: z.coerce.string().trim().min(1),
  name: z.coerce.string(),
});
